
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from '../../../home/components/Footer';

export default function ThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="bg-slate-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-28">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-48 h-24 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/ac092ddd5e8296cd231c029d8c3ac0cf.png"
                  alt="unuu Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-white transition-colors hover:text-[#00989e] whitespace-nowrap">
                Services
              </Link>
              <Link to="/case-studies" className="text-sm font-medium text-white transition-colors hover:text-[#00989e] whitespace-nowrap">
                Case Studies
              </Link>
              <Link to="/about" className="text-sm font-medium text-white transition-colors hover:text-[#00989e] whitespace-nowrap">
                About
              </Link>
              <Link to="/blog" className="text-sm font-medium text-white transition-colors hover:text-[#00989e] whitespace-nowrap">
                Blog
              </Link>
              <Link to="/contact" className="px-6 py-2.5 bg-[#00989e] text-white text-sm font-semibold rounded-full hover:bg-[#007a7f] transition-colors whitespace-nowrap cursor-pointer">
                Let's Talk
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Thank You Content */}
      <section className="py-24 lg:py-32">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="w-24 h-24 mx-auto mb-8 bg-gradient-to-br from-[#00989e] to-[#00b4a6] rounded-full flex items-center justify-center animate-bounce">
            <i className="ri-check-line text-5xl text-white"></i>
          </div>

          <h1 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Thank You for Your Enquiry!
          </h1>
          
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            We've received your project details and are excited to learn more about your vision. 
            Our team will review your requirements and get back to you within <strong>24-48 hours</strong>.
          </p>

          {/* What Happens Next */}
          <div className="bg-slate-50 rounded-2xl p-8 mb-12 text-left">
            <h2 className="text-xl font-bold text-slate-900 mb-6 text-center">What Happens Next?</h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-10 h-10 bg-[#00989e] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Review Your Requirements</h3>
                  <p className="text-slate-600 text-sm">Our team will carefully review your project details and requirements.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 bg-[#00989e] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Discovery Call</h3>
                  <p className="text-slate-600 text-sm">We'll schedule a call to discuss your project in detail and answer any questions.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-10 h-10 bg-[#00989e] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">3</span>
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">Custom Proposal</h3>
                  <p className="text-slate-600 text-sm">You'll receive a tailored proposal with timeline, pricing, and project scope.</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link 
              to="/case-studies" 
              className="px-8 py-3.5 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap"
            >
              View Our Work
            </Link>
            <Link 
              to="/" 
              className="px-8 py-3.5 border-2 border-slate-300 text-slate-700 font-semibold rounded-full hover:border-[#00989e] hover:text-[#00989e] transition-colors cursor-pointer whitespace-nowrap"
            >
              Back to Home
            </Link>
          </div>

          {/* Contact Info */}
          <div className="border-t border-slate-200 pt-8">
            <p className="text-slate-600 mb-4">Have an urgent question? Reach out directly:</p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a href="mailto:maria@unuu.co.uk" className="flex items-center justify-center gap-2 text-[#00989e] hover:text-[#007a7f] transition-colors cursor-pointer">
                <i className="ri-mail-line text-lg"></i>
                <span className="font-medium">maria@unuu.co.uk</span>
              </a>
              <a href="tel:+447810306008" className="flex items-center justify-center gap-2 text-[#00989e] hover:text-[#007a7f] transition-colors cursor-pointer">
                <i className="ri-phone-line text-lg"></i>
                <span className="font-medium">+44 7810 306 008</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
